import useNowPlayingMovies from "../hooks/useNowPlayingMovies";
import Header from "./Header";
import MainContainer from "./MainContainer";
import SecondaryContainer from "./SecondaryContainer";
import usePopularMovies from "../hooks/usePopularMovies";
import useTopRatedMovies from "../hooks/useTopRatedMovies";
import useUpcomingMovies from "../hooks/useUpcoming";
import GptSearch from "./GptSearch";
import { useSelector } from "react-redux";

const Browse = () => {

  const showGptSearch = useSelector(store => store.gpt.showGptSearch)
  

  useUpcomingMovies();
  useNowPlayingMovies();
  usePopularMovies();
  useTopRatedMovies();
  
  return (
    <div>
      <Header/>
      {showGptSearch ? (
        <GptSearch/>
      )  : (
        <>
        <MainContainer/>
        <SecondaryContainer/>
        </>
      )}
      
      
      
      
    </div>
  );
};

export default Browse;
